var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNdviCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_6326)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0792 17.0848C35.9259 13.3443 32.5594 10.648 28.5851 10.648C28.3981 10.648 28.211 10.648 28.024 10.648C26.8551 6.33082 23.8315 2.83967 19.8884 1.15644C18.2363 0.439503 16.4284 0.0498657 14.527 0.0498657C6.78096 0.0654512 0.5 6.58019 0.5 14.5911C0.5 19.8746 3.21188 24.5035 7.2797 27.044C9.08762 28.1817 11.1917 28.6804 13.3269 28.7428L28.2422 29.1168H28.5695C33.4945 29.1168 37.4844 24.9711 37.4844 19.8746C37.4844 18.9083 37.3442 17.9576 37.0636 17.0692L37.0792 17.0848ZM28.6474 26.4829H28.2422L13.0308 25.9686C11.2384 25.9062 9.47726 25.3919 8.01222 24.3477C5.09773 22.2125 3.14954 18.659 3.14954 14.5756C3.14954 7.93613 8.32393 2.71499 14.5114 2.71499C15.8673 2.71499 17.1609 2.96436 18.361 3.41634C21.8833 4.7411 24.6108 7.81145 25.5459 11.6922C25.7174 12.4092 25.842 13.1573 25.8732 13.9366C26.6837 13.5157 27.6032 13.282 28.5539 13.282C31.0164 13.282 33.214 14.8093 34.2426 17.0848C34.6167 17.9264 34.8349 18.8772 34.8349 19.8902C34.8349 23.5996 31.9671 26.4517 28.6318 26.4829H28.6474Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_6326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 29.067,
    fill: "white",
    transform: "translate(0.5 0.0653076)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdviCloud);
export default __webpack_public_path__ + "static/media/ndvi-cloud.d7c4b1fb75e207cffc710a9e5482515a.svg";
export { ForwardRef as ReactComponent };